import { render, staticRenderFns } from "./NewPermissionForm.vue?vue&type=template&id=f95080c4&scoped=true&"
import script from "./NewPermissionForm.vue?vue&type=script&lang=js&"
export * from "./NewPermissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95080c4",
  null
  
)

export default component.exports